module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "categoryDetails"
  }, [(!_vm.isMobile() && _vm.showEditTrigger) ? _c('edit-category-trigger', {
    staticClass: "editIcon subcategory",
    attrs: {
      "categoryId": _vm.categoryId
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    on: {
      "click": _vm.emitCategoryClick
    }
  }, [_vm._v("\n    " + _vm._s(_vm.getCategoryName(_vm.categoryId)) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64b0e079!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/SubcategoryDetailsBlock.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-64b0e079!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/SubcategoryDetailsBlock.vue
// module chunks = 0